export interface InactivityDialogProps {
  secondsLeft: number;
  onStay: () => void;
  onEnd: () => void;
}

/**
 * Shown when a live meeting has had no speech for several minutes. Clicking the
 * backdrop counts as "stay" (the safe choice); if the user does nothing the
 * caller auto-ends when the countdown reaches zero.
 */
export function InactivityDialog({ secondsLeft, onStay, onEnd }: InactivityDialogProps) {
  return (
    <div className="modal-back" onClick={onStay}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3 className="modal-title">Are you still in the meeting?</h3>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0, color: "var(--text-2)", lineHeight: 1.5 }}>
            We haven't heard anyone for a few minutes. This meeting will end automatically in{" "}
            <strong>{secondsLeft}s</strong> unless you choose to stay.
          </p>
        </div>
        <div className="modal-foot">
          <button type="button" className="pill-btn" onClick={onEnd}>
            End meeting
          </button>
          <button type="button" className="pill-btn primary" onClick={onStay}>
            Stay in meeting
          </button>
        </div>
      </div>
    </div>
  );
}
